import { render } from "./BudgetEntryPrices.vue?vue&type=template&id=38504f25&ts=true"
import script from "./BudgetEntryPrices.vue?vue&type=script&lang=ts"
export * from "./BudgetEntryPrices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__